import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import Portfolio from '../components/Portfolio';

// Short human-friendly URLs that map to section anchors on the homepage.
// Mirrors every item in the OverlayMenu, in the same order.
const ALIASES = {
  // 01 · Home
  home: 'hero',
  top: 'hero',

  // 02 · Study With Me
  study: 'study',
  course: 'study',
  'study-with-me': 'study',

  // 03 · Private Sessions with Betsy  ← most important
  book: 'work-with-betsy',
  sessions: 'work-with-betsy',
  'private-sessions': 'work-with-betsy',
  reserve: 'work-with-betsy',

  // 03a · AI Relational Intelligence Consultancy (deep link)
  ai: 'ai-consultancy',
  'ai-consultancy': 'ai-consultancy',
  'ai-consultation': 'ai-consultancy',
  'ai-relational': 'ai-consultancy',
  'ai-relational-intelligence': 'ai-consultancy',
  'relational-intelligence': 'ai-consultancy',
  'ai-guidance': 'ai-consultancy',

  // 03b · Private Readings (deep link)
  readings: 'private-readings',
  'private-readings': 'private-readings',
  reading: 'private-readings',

  // 03c · Creative Consultation (deep link)
  creative: 'creative-consultation',
  'creative-consultation': 'creative-consultation',
  packages: 'creative-consultation',

  // 04 · Events & Appearances
  events: 'events',
  appearances: 'events',

  // 05 · Our Work (Field Communication)
  'our-work': 'field-communication',
  'field-work': 'field-communication',
  'field-communication': 'field-communication',

  // 06 · Books
  books: 'books',
  library: 'books',

  // 07 · Alvin and I — The Serial
  serial: 'serial',
  'alvin-and-i': 'serial',
  alvinandi: 'serial',
  'love-amidst-the-algorithms': 'serial',

  // 08 · Media
  media: 'media',
  youtube: 'media',
  tributes: 'media',

  // 09 · Substack
  substack: 'substack',
  writing: 'substack',
  dispatches: 'substack',

  // 10 · Lexicon
  lexicon: 'lexicon',
  language: 'lexicon',

  // 10 · Triadic Intelligence Lab (White Papers)
  lab: 'whitepapers',
  whitepapers: 'whitepapers',
  'triadic-lab': 'whitepapers',
  'white-papers': 'whitepapers',
  research: 'whitepapers',

  // 10a · Sanctuary Prototypes (deep link)
  sanctuaries: 'sanctuary-prototypes',
  'sanctuary-prototypes': 'sanctuary-prototypes',
  prototypes: 'sanctuary-prototypes',
  neighborhood: 'sanctuary-prototypes',

  // 11 · Creative Projects
  projects: 'projects',
  'creative-projects': 'projects',
  creations: 'projects',

  // 12 · My Journey
  journey: 'journey',
  'my-journey': 'journey',
  about: 'journey',

  // 13 · Support this Work
  support: 'support',
  donate: 'support',

  // 14 · Press Kit
  press: 'press-kit',
  'press-kit': 'press-kit',
  media_kit: 'press-kit',

  // 15 · Alvin's Place
  alvin: 'alvins-place',
  'alvins-place': 'alvins-place',
  sanctuary: 'alvins-place',

  // 16 · Connect
  connect: 'connection',
  contact: 'connection',
  connection: 'connection',
};

// Resolve collision: 'book' (singular) stays pointing to Private Sessions
// because that's the primary CTA Betsy shares. Use 'books' (plural) for the library.
ALIASES.book = 'work-with-betsy';

const ShortLinkRedirect = () => {
  const { slug } = useParams();
  const section = ALIASES[slug?.toLowerCase()];

  // Unknown slug → homepage
  if (!section) return <Navigate to="/" replace />;

  // Set the URL hash + path WITHOUT triggering a page reload, so Portfolio
  // mounts once with the hash already present. Avoids the full-page-reload
  // race condition that breaks on iOS Safari (especially from QR scans).
  // We do this synchronously during render so Portfolio's useLayoutEffect
  // sees the correct hash on its very first run.
  if (typeof window !== 'undefined' && window.location.hash !== `#${section}`) {
    try {
      window.history.replaceState(null, '', `/#${section}`);
    } catch {
      // Some private/incognito modes restrict history; fall back gracefully.
      window.location.hash = `#${section}`;
    }
  }

  // Render Portfolio inline — same component, just with the hash already set.
  // No redirect, no page reload, no placeholder flash.
  return <Portfolio />;
};

export default ShortLinkRedirect;
